const questionIconMap = {
  text: 'file-text',
  number: 'list-ol',
  textarea: 'file-text',
  checkbox: 'check-square',
  dropdown: 'caret-down',
  radio: 'circle-o',
  image_upload: 'picture-o',
  multiple_image_upload: 'picture-o',
  image_capture: 'camera',
  multiple_image_capture: 'camera',
  location_map: 'map',
  location_stamp: 'map-marker',
  voice_record: 'microphone',
  email: 'envelope-o',
  phone_number: 'phone',
  date: 'calendar',
  date_time: 'calendar',
  range: 'sliders',
  yes_no: 'check',
  information: 'bullhorn',
  tag: 'plus-square-o',
  ordering: 'sort',
  video_capture: 'play'
};

export default questionIconMap;


// WEBPACK FOOTER //
// ./src/constants/task-form/question-icon-map.js